export const RELATED_MODEL = {
  patient_medication: "patient_medication",
  patient_checkin: "patient_checkin",
  script_request: "script_request",
  patient_bundle: "patient_bundle",
  patient: "patient",
  patient_checkin_schedule: "patient_checkin_schedule",
  note: "note",
  consultation: "consultation",
  consultation_details: "consultation_details",
  organization_patient: "organization_patient",
} as const;

export type RelatedModelType =
  (typeof RELATED_MODEL)[keyof typeof RELATED_MODEL];

export const ACTIVITY_FEED_CODES = {
  consultation_requested: "consultation_requested",
  patient_archived: "patient_archived",
  closed_after_screening: "closed_after_screening",
  consultation_completed: "consultation_completed",
  consultation_report_completed: "consultation_report_completed",
  screening_started: "screening_started",
  screening_submitted: "screening_submitted",
  screening_completed: "screening_completed",
  intake_started: "intake_started",
  intake_submitted: "intake_submitted",
  appointment_scheduled: "appointment_scheduled",
  bundle_ordered: "bundle_ordered",
  checkin_ordered: "checkin_ordered",
  checkin_submitted: "checkin_submitted",
  checkin_missed: "checkin_missed",
  checkin_deleted: "checkin_deleted",
  medication_added: "medication_added",
  medication_modified: "medication_modified",
  medication_discontinued: "medication_discontinued",
  prescription_paused: "prescription_paused",
  prescription_resumed: "prescription_resumed",
  note_added: "note_added",
  prescription_requested: "prescription_requested",
  prescription_cancelled: "prescription_cancelled",
  prescription_sent_to_pharmacy: "prescription_sent_to_pharmacy",
  prescription_issue_reported: "prescription_issue_reported",
  ongoing_care: "ongoing_care",
  patient_created: "patient_created",
  recurrent_checkin_ordered: "recurrent_checkin_ordered",
  consultation_terminated: "consultation_terminated",
  consultation_re_opened: "consultation_re_opened",
  patient_promoted_to_intake: "patient_promoted_to_intake",
  patient_admitted_into_practice: "patient_admitted_into_practice",
  primary_provider_changed: "primary_provider_changed",
  patient_signed_consent_forms: "patient_signed_consent_forms",
} as const;

export type ActivityFeedCode =
  (typeof ACTIVITY_FEED_CODES)[keyof typeof ACTIVITY_FEED_CODES];
